import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, Typography } from 'antd';

import ModalActions from 'components/ModalActions';
import { agent, API_MAP } from 'helpers';
import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';
import Alumy from 'scenes/Producer/Product/components/Partners/Alumy';

type CreateVariationProps = {
  product: IProduct;
};

function CreateVariation({ product }: CreateVariationProps) {
  const [isVariationLoading, setIsVariationLoading] = useState(false);
  const [showVariationModal, setShowVariationModal] = useState(false);
  const history = useHistory();

  const isService = product.type === constants.SERVICE;
  const isTicket = product.type === constants.TICKET;

  const canCreateVariationButton = !isService && !isTicket;

  function handleOpenVariationModal() {
    setShowVariationModal(true);
  }

  function handleVariationModalClose() {
    setShowVariationModal(false);
  }

  function handleVariationModalOk() {
    setIsVariationLoading(true);
    createNewVariation();
  }

  function handleCloneProductById(id: number, parentId: number) {
    const baseUrl = `${API_MAP.cloneProductById}`.replace('{id}', id.toString());
    const requestUrl = `${baseUrl}?parent_id=${parentId.toString()}`;

    return agent.post(requestUrl, {});
  }

  function createNewVariation() {
    if (Alumy.isAlumy(product.cnt_partner_cod)) {
      Alumy.alumyModal();
      return;
    }

    handleCloneProductById(product.id, product.id)
      .then(() => history.push(`/producer/product/editproduct/${product.id}`))
      .catch(error => toast.error(error))
      .finally(() => {
        handleVariationModalClose();
        setIsVariationLoading(false);
      });
  }

  if (!canCreateVariationButton) return null;

  return (
    <>
      <div>
        <Typography.Paragraph>
          Você pode continuar configurando esse produto e cadastrar novas variações:
        </Typography.Paragraph>
        <Button id='new-product-create-variation' type='dashed' block onClick={handleOpenVariationModal}>
          + Criar variação
        </Button>
      </div>

      <ModalActions
        title={'Deseja realmente criar variações para este produto?'}
        open={showVariationModal}
        onClose={handleVariationModalClose}
        onOk={handleVariationModalOk}
        buttonOk={'Sim, criar variação'}
        buttonCancel={'Não'}
        loading={isVariationLoading}
      >
        <Typography.Paragraph>
          Após a criação de uma variação o conteúdo deverá ter no{' '}
          <Typography.Text strong>mínimo 2 variações</Typography.Text>, esta alteração não poderá ser desfeita.
        </Typography.Paragraph>
      </ModalActions>
    </>
  );
}

export default CreateVariation;
